module.exports = __webpack_public_path__ + "pic_bizny_web_06@2x.png?2a7e3740878d4109b4e46a2dfad2291a";